// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as PartnerEngagement from "../../../../app/filter-partners/entity/PartnerEngagement.bs.js";
import * as ListUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ListUtils.bs.js";

function getCityOptions(geoRegions) {
  return List.map((function (region) {
                return {
                        key: String(region.id),
                        value: String(region.id),
                        text: region.name
                      };
              }), geoRegions);
}

function getVehicleOptions(vehicleTypes) {
  return List.map((function (vehicle) {
                return {
                        key: String(vehicle.vehicle_id),
                        value: String(vehicle.vehicle_id),
                        text: vehicle.vehicle.vehicle_type
                      };
              }), vehicleTypes);
}

var engagementTypeChecboxes = List.mapi((function (index, engagement) {
        return {
                id: "engagementChecboxes" + String(index),
                label: PartnerEngagement.to_string(engagement),
                value: PartnerEngagement.to_string(engagement)
              };
      }), PartnerEngagement.engagement_types);

function getSelectedItem(value, options) {
  return List.find_opt((function (o) {
                return value === o.value;
              }), options);
}

function isChecked(selected, currentValue) {
  return ListUtils$Catalyst.find(selected, (function (value) {
                return value === currentValue;
              })) !== undefined;
}

var availabilityChecboxes = {
  hd: {
    id: "availabilityChecboxes-1",
    label: "Available",
    value: "available"
  },
  tl: /* [] */0
};

var gpsLocationChecboxes = {
  hd: {
    id: "locationChecboxes-1",
    label: "Location not updated in last 2 hours",
    value: "location_not_updated"
  },
  tl: /* [] */0
};

var statusChecboxes = {
  hd: {
    id: "statusChecboxes-1",
    label: "Free",
    value: "free"
  },
  tl: {
    hd: {
      id: "statusChecboxes-2",
      label: "Allocated",
      value: "allocated"
    },
    tl: /* [] */0
  }
};

export {
  getCityOptions ,
  getVehicleOptions ,
  engagementTypeChecboxes ,
  availabilityChecboxes ,
  gpsLocationChecboxes ,
  statusChecboxes ,
  getSelectedItem ,
  isChecked ,
  
}
/* engagementTypeChecboxes Not a pure module */
